import { Component } from 'react';
import { Flow } from 'flow-react';
import { observer } from "mobx-react"
import { Container, Row} from 'react-bootstrap';
import './Genresmenu.css';


const Genresmenu = observer(
  class Genresmenu extends Component {
	
		//mapping der Chains auf classnames, das wird in der reihenfolge durchgegangen 
		//"France 3 Régions","france_3_regions" ist nicht ddrin weil es keinen eigenen menuepunkt hat
		genres = ["Culture","Divertissement","Documentaire","Film cinéma","Éducation","Information","Innovation","Jeunesse","Magazine","Série et Fiction","Série numérique","Sport"];
		gclass = ["culture","divertissement","documentaire","film_cinema","education","information","innovation","jeunesse","magazine","serie_et_fiction","serie_numerique","sport"];		//genres sind nur dazu da: wenn man ein genre in seinen stations hat, bekommt man immer alle chains
		
		//wenn man mideseten einen chain hat, zeige alle Genres
		chains = ["France 2","France 3","France 4","France 5","Réseau la 1ère","Outre-Mer la 1ère","france.tv distribution","francetv-la plateforme"];
		
		//Klassennamen zu Meta
		cTom = (c) => {
			return this.genres[this.gclass.indexOf(c)];
		}
		//Meta zu Klassennamen
		mToc = (c) => {
			return this.gclass[this.genres.indexOf(c)];
		}
		
		
		
		toggleGenre(c) {
			// c = this.cTom(c);
			let ch = this.props.skgenres;
			if(ch.indexOf(c) > -1)  
				ch.splice(ch.indexOf(c),1)
			else
				ch.push(c);
			this.props.setcritcb({genres:ch});
		}
		
		//das macht ein array mit klassennamen von genres, die man angezeigt bekommt
		getStations = () => {
			let us = this.props.user.stations;
			let erg = [];
			for(var g of this.chains)
				if(us.indexOf(g) > -1)
					return this.gclass;//wenn es ein chain gibt, zeige alle genres an
			for(var c of this.genres) {
				if(us.indexOf(c) > -1)
					erg.push(c);
			}
			return erg;
		}
		
		
		mkAddClass = (cl) => {
			if(this.props.skgenres.indexOf(cl) > -1) 
				return ' selected';
			return '';
		}
		
    render() {
			return  (
				<>
				<div className="genresbigheader">Genres</div>
				<ul className="genresbiglist">
				{this.genres.map(c => {
					return (
						<li 
							key={c} 
							onClick={()=>{ this.toggleGenre(c) }}
							className={'genresbig chb_' + c + this.mkAddClass(c)}>
								{c}
						</li>)
				})
				}
				</ul>
				</>
			)
    }
		

		
		
  }
)


export default Flow.injectFlow(Genresmenu);